import { RadioItem, RadioPillItem, Container } from "./components";

export type { RadioItemProps, RadioPillItemProps, GroupedRadioContainerProps } from "./components";

export const GroupedRadio = Object.assign(Container, {
  Radio: RadioItem,
  Pill: RadioPillItem,
});
